<!--
 * @Description: 修改密码对话框组件
 * @Author: laoliu,wanqian
 * @Date: 2021-04-20 16:56:28
 * @LastEditTime: 2022-11-08 13:51:50
-->
<template>
  <el-dialog class="body dialog-underline" width="640px" height="320px" title="" 
    :visible.sync="visible" :close-on-click-modal="false" @open="initData" :before-close='handleCancel' center>
    <div slot="title">
      <span class="header-title">修改账户密码</span>
    </div>
    <el-form class="form" ref="form" :model="form" :rules="rules" label-width="150px">
      <el-form-item label="原密码" prop="originalPassword">
        <el-input style="width: 320px" v-model="form.originalPassword" placeholder="请输入原密码" 
          size="small" autocomplete="off" :type="typeOriginalPassswd">
          <i slot="suffix" style="margin-right: 5px" :class="classOriginalPassswd" @click="showOriginalPassswd"></i>
        </el-input>
      </el-form-item>
      <el-form-item label="新密码" prop="newPassword" style="margin-top: -3px;">
        <el-input style="width: 320px" v-model="form.newPassword" placeholder="请输入新密码" 
          size="small" autocomplete="off" :type="typeNewPassswd">
          <i slot="suffix" style="margin-right: 5px" :class="classNewPassswd" @click="showNewPassswd"></i>
        </el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="confirmPassword" style="margin-top: -3px;">
        <el-input style="width: 320px" v-model="form.confirmPassword" placeholder="请再次输入确认密码"
          size="small" autocomplete="off" :type="typeAgainPassswd">
          <i slot="suffix" style="margin-right: 5px" :class="classAgainPassswd" @click="showAgainPassswd"></i>
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" style="margin: -30px 0 10px 0">
      <el-button size="small" @click="handleCancel">取 消</el-button>
      <el-button type="primary" size="small" @click="handleSubmit('form')">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Constant from '@/global/Constant.js'

let ChangePwdDialog = {
  name: 'ChangePwdDialog',
  props: ["visible"],
  
  data() {
    let validateConfirmPwd = (_rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入确认密码'));
      } else if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      form: {},
      rules: {
        originalPassword: [{required: true, message: '请输入原密码', trigger: 'blur'}],
        newPassword: [{required: true, message: '请输入新密码', trigger: 'blur'}],
        confirmPassword: [{required: true, validator: validateConfirmPwd, trigger: 'blur'}]
      },
      typeOriginalPassswd: 'password',
      classOriginalPassswd: 'el-icon-close-eye',
      typeNewPassswd: 'password',
      classNewPassswd: 'el-icon-close-eye',
      typeAgainPassswd: 'password',
      classAgainPassswd: 'el-icon-close-eye',
    }
  },

  methods: {
    initData() {
      this.typeOriginalPassswd = 'password';
      this.classOriginalPassswd = 'el-icon-close-eye';
      this.typeNewPassswd = 'password';
      this.classNewPassswd = 'el-icon-close-eye';
      this.typeAgainPassswd = 'password';
      this.classAgainPassswd = 'el-icon-close-eye';
    },

    showOriginalPassswd() {
      //点击图标是密码隐藏或显示
      this.typeOriginalPassswd = (this.typeOriginalPassswd==="text") ? 'password' : 'text';
      this.classOriginalPassswd = (this.typeOriginalPassswd==="text") ? 'el-icon-open-eye' : 'el-icon-close-eye';
    },

    showNewPassswd() {
      this.typeNewPassswd = (this.typeNewPassswd==="text") ? 'password' : 'text';
      this.classNewPassswd = (this.typeNewPassswd==="text") ? 'el-icon-open-eye' : 'el-icon-close-eye';
    },

    showAgainPassswd() {
      this.typeAgainPassswd = (this.typeAgainPassswd==="text") ? 'password' : 'text';
      this.classAgainPassswd = (this.typeAgainPassswd==="text") ? 'el-icon-open-eye' : 'el-icon-close-eye';
    },

    clearData() {
      this.form = {};
      this.$refs['form'].clearValidate();
    },
    
    handleSubmit(form) {
      this.$refs[form].validate((valid) => {
        if (!valid) return false;
        //加密+签名
        let [header, esParam] = this.encryptionUtil.encryptAndSignAllParams({...this.form},
          Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'PUT',
          url: Constant.URL_UPDATE_PASSWORD,
          param: esParam,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
          showSuccMsg: true,
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.clearData();
            this.$emit("close-dialog", true);
            this.handleLogout();
          }
        })
      });
    },

    handleLogout() {
      this.appAxios("POST", Constant.URL_LOGOUT).then(_data => {
        let adminType = sessionStorage.getItem(Constant.SESSION_ADMIN_TYPE);
        let identifier = sessionStorage.getItem(Constant.SESSION_IDENTIFIER);
        this.$router.push({
          name: 'login', params: {'adminType': adminType, 'identifier': identifier}
        });
      })
    },

    handleCancel() {
      this.clearData();
      this.$emit("close-dialog", false);
    }
  },
}
export default ChangePwdDialog
</script>

<style scoped>
.body {
  text-align: left;
}
.header-title {
  font-size: 15px;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/personal/components/ChangePwdDialog.vue